import OTCLanding from '~/components/OTCLanding'

export default OTCLanding
